// import React from 'react';
// import { Table, Text, Loader, Center } from '@mantine/core';

// const UniversalTable = ({ 
//   headers, 
//   data, 
//   loading, 
//   emptyMessage = "No records found" 
// }) => {
//   return (
//     <div className="border border-gray-200 rounded-xl shadow-sm overflow-hidden bg-white mt-4">
//       <div className="overflow-x-auto"> {/* Handles mobile/small screens */}
//         <Table verticalSpacing="md" horizontalSpacing="lg" highlightOnHover>
//           <thead className="bg-gray-50/50">
//             <tr>
//               {headers.map((header, index) => (
//                 <th key={index} style={{ 
//                   color: '#6B7280', 
//                   fontSize: '11px', 
//                   fontWeight: 700, 
//                   textTransform: 'uppercase', 
//                   letterSpacing: '0.5px',
//                   textAlign: header.align || 'left',
//                   width: header.width || 'auto'
//                 }}>
//                   {header.label}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan={headers.length}>
//                   <Center py="xl"><Loader size="sm" variant="dots" /></Center>
//                 </td>
//               </tr>
//             ) : data?.length > 0 ? (
//               data.map((row, rowIndex) => (
//                 <tr key={row.id || rowIndex} className="hover:bg-slate-50/50 transition-colors">
//                   {headers.map((header, colIndex) => (
//                     <td key={colIndex} style={{ textAlign: header.align || 'left' }}>
//                       {/* CRITICAL: We pass 'row' AND 'rowIndex' to the render function. 
//                         This allows you to handle SR No. and conditional logic perfectly.
//                       */}
//                       {header.render ? header.render(row, rowIndex) : (
//                         <Text size="sm">{row[header.key] || "--"}</Text>
//                       )}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={headers.length} className="py-20 text-center text-gray-400">
//                   <Text size="sm" italic>{emptyMessage}</Text>
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       </div>
//     </div>
//   );
// };

// export default UniversalTable;
import React from 'react';
import { Table, Text, Loader, Center } from '@mantine/core';

const UniversalTable = ({ 
  headers, 
  data, 
  loading, 
  emptyMessage = "No records found" 
}) => {
  return (
    <div className="mt-6 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm ring-1 ring-black ring-opacity-5">
      <div className="overflow-x-auto">
        <Table 
          verticalSpacing="sm" 
          horizontalSpacing="lg" 
          highlightOnHover 
          withColumnBorders={false}
          className="min-w-full divide-y divide-slate-200"
          // style={{ tableLayout: 'fixed' }}
        >
          {/* Header section with refined typography */}
          <thead className="bg-slate-50/80 backdrop-blur-sm sticky top-0 z-10">
            <tr>
              {headers.map((header, index) => (
                // <th 
                //   key={index} 
                //   style={{ 
                //     color: '#64748b', // Slate 500
                //     fontSize: '12px', 
                //     fontWeight: 600, 
                //     textTransform: 'uppercase', 
                //     letterSpacing: '0.05em',
                //     textAlign: header.align || 'left',
                //     width: header.width || 'auto',
                //     paddingTop: '16px',
                //     paddingBottom: '16px',
                //     borderBottom: '1px solid #e2e8f0'
                //   }}
                // >
                //   {header.label}
                // </th>
                // Inside UniversalTable.js map function for headers:
            <th 
              key={index} 
              style={{ 
                color: '#64748b',
                fontSize: '12px', 
                fontWeight: 600, 
                // textTransform: 'uppercase', // REMOVE OR COMMENT THIS OUT
                letterSpacing: '0.05em',
                textAlign: header.align || 'left',
 width: header.width || 'auto',
    // minWidth: header.width || '80px',
                    paddingTop: '8px', // Reduced padding to fit inputs better
                paddingBottom: '8px',
                borderBottom: '1px solid #e2e8f0',
                position: 'relative' // Ensure dropdowns position correctly
              }}
            >
              {header.label}
            </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="divide-y divide-slate-100 bg-white">
            {loading ? (
              <tr>
                <td colSpan={headers.length}>
                  <Center py={60}>
                    <Loader size="md" variant="dots" color="#1b6f8d" />
                  </Center>
                </td>
              </tr>
            ) : data?.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr 
                  key={row.id || rowIndex} 
                  className="group transition-all duration-200 hover:bg-blue-50/30"
                >
                  {headers.map((header, colIndex) => (
                    <td 
                      key={colIndex} 
                      style={{ 
                        textAlign: header.align || 'left',
                        paddingTop: '14px',
                        paddingBottom: '14px'
                      }}
                      className="whitespace-nowrap"
                    >
                      {header.render ? (
                        header.render(row, rowIndex)
                      ) : (
                        <Text size="sm" weight={500} className="text-slate-700">
                          {row[header.key] ?? "--"}
                        </Text>
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="py-24 text-center">
                  <div className="flex flex-col items-center justify-center">
                    <Text size="sm" className="font-medium text-slate-400 italic">
                      {emptyMessage}
                    </Text>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default UniversalTable;